import { render, staticRenderFns } from "./MenuDoubleLayer.vue?vue&type=template&id=3a389535&scoped=true"
import script from "./MenuDoubleLayer.vue?vue&type=script&lang=js"
export * from "./MenuDoubleLayer.vue?vue&type=script&lang=js"
import style0 from "./MenuDoubleLayer.vue?vue&type=style&index=0&id=3a389535&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a389535",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a389535')) {
      api.createRecord('3a389535', component.options)
    } else {
      api.reload('3a389535', component.options)
    }
    module.hot.accept("./MenuDoubleLayer.vue?vue&type=template&id=3a389535&scoped=true", function () {
      api.rerender('3a389535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/MenuDoubleLayer.vue"
export default component.exports